import { render, staticRenderFns } from "./TableHeaderShare.vue?vue&type=template&id=245757ce&scoped=true"
import script from "./TableHeaderShare.vue?vue&type=script&lang=js"
export * from "./TableHeaderShare.vue?vue&type=script&lang=js"
import style0 from "./TableHeaderShare.vue?vue&type=style&index=0&id=245757ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245757ce",
  null
  
)

export default component.exports